<template>
  <v-tabs v-model="tab" color="primary" dark centered flat slider-color="white">
    <v-tab v-for="(lang, index) in localValue" :key="index + 100">
      {{ lang.name }}
    </v-tab>
    <v-tab-item v-for="(lang, index) in localValue" :key="index + 200">
      <v-layout wrap>
        <v-flex xs12>
          <v-text-field
            v-if="lang.iso === defaultValues.languageRequire"
            v-model="lang.text"
            v-validate="validations"
            :label="localLabel(true)"
            :data-vv-name="label"
            :error-messages="errors.collect(label)"
            @input="onChange"
          />
          <v-text-field
            v-else
            v-model="lang.text"
            :label="localLabel(false)"
            @input="onChange"
          />
        </v-flex>
      </v-layout>
    </v-tab-item>
  </v-tabs>
</template>

<script>
export default {
  name: 'TranslationField',
  props: {
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      tab: 0,
    }
  },
  computed: {
    localValue: {
      get() {
        return this.converter(this.value)
      },
      set(value) {
        this.$emit('input', value)
      },
    },

    validations() {
      return this.required ? 'required' : ''
    },
  },
  watch: {
    value(val) {
      if (val && val.length === 0) this.tab = 0
    },
  },
  methods: {
    localLabel(isoRequired) {
      let label = this.label
      if (this.required && isoRequired) label += ' *'
      return label
    },
    onChange() {
      let name = []
      this.localValue.forEach((item) => {
        if (item.text) name.push(item)
      })
      this.$emit('input', name)
    },
  },
}
</script>
